import http from "../../plugins/axios";

export default {
    roleOptions(data) {
        return http.get({
            url: '/la/admin/tenant/role/options',
            data
        })
    },
    tenantUserList(data) {
        return http.get({
            url: '/la/admin/tenant/user/list',
            data
        })
    },
    tenantUserAdd(data) {
        return http.post({
            url: `/la/admin/tenant/user/add`,
            data,
            dataType: 'form'
        });
    },
    deleteGoogle(data) {
        return http.post({
            url: `/la/admin/tenant/user/deleteGoogle`,
            data,
            dataType: 'form'
        })
    },

    resetPassword(data) {
        return http.post({
            url: `/la/admin/tenant/user/resetPassword`,
            data,
            dataType: 'form'
        })
    },
    userEdit(data) {
        return http.post({
            url: `/la/admin/tenant/user/edit`,
            data,
            dataType: 'form'
        })
    },


    disableLogin(data) {
        return http.post({
            url: `/la/admin/tenant/user/disable/login`,
            data,
            dataType: 'form'
        })
    },

    remove(data) {
        return http.post({
            url: `/la/admin/tenant/user/remove`,
            data,
            dataType: 'form'
        })
    },

};
